import { navigationIsBranch } from '~/lib/navigation';

export default defineNuxtRouteMiddleware(async (to, from) => {
	if (import.meta.server) return;

	
	const isMenuOpen = useState('drawer');

	const links = useState<any[]>('navigationLinks');
	const keepMenuOpen = navigationIsBranch(links.value || [], to.path);
	if (!keepMenuOpen) isMenuOpen.value = false;
	// Search and filters update the query without leaving the page.
	if (!keepMenuOpen && to.path !== from.path) document.activeElement?.blur();

	// Authenticated visits are recorded by plugins/presence.client.ts.
})
